import React, { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import styles from './DashboardHeader.module.css';
import { useNavigate } from 'react-router-dom';
import {
  Home,
  Search,
  HelpOutline,
  Notifications,
  WbSunny,
  KeyboardArrowDown,
  Logout,
  ChevronLeft
} from '@mui/icons-material';

import uniliverLogoWithTextBelow  from "../../../assets/images/uniliver_lcon_with_label_below.svg";
import samarthLogo  from "../../../assets/images/samarth-logo.png";


const DashboardHeader = ({ weekCurrent }) => {
  const { instance, accounts } = useMsal();
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const account = accounts[0];
      setUserInfo({
        name: account.name || account.username || 'User',
        email: account.username || account.email || '',
        role: account.idTokenClaims?.roles?.[0] || account.idTokenClaims?.extension_Role || 'User',
        avatar: null, 
        initials: getInitials(account.name || account.username || 'User')
      });
    }
  }, [accounts]);

  const handleBackClick = () => {
    navigate('/')
  };

  const handleHomeClick = () => {
    navigate('/samarth')
  };

  const handleLogout = () => {
    setShowDropdown(false);
      instance.logoutRedirect({
        postLogoutRedirectUri: window.location.origin
      });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit', 
      hour12: true 
    });
  };

  const getUserInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
  };

  const getCurrentWeek = () => {
    return weekCurrent ? weekCurrent.split(" ")?.pop() || "--" : "--";
  };

  return (
    <header className={styles.header}>
      {/* Left section with logo and title */}
      <div className={styles.leftSection}>
        {/* Unilever logo */}
        <div className={styles.logo}>
          <img src={uniliverLogoWithTextBelow} alt="Unilever" />
        </div>

        {/* Vertical divider */}
        <div className={styles.divider}></div>

        {/* Center logo and title */}
        <div className={styles.centerSection}>
          <div>
            <img 
              src={samarthLogo} 
              alt="SC Nerve Center" 
              className={styles.centerLogo}
            />
          </div>
          <div className={styles.titleSection}>
            <h1>SAMARTH-(SC NERVE CENTER)</h1>
            <div className={styles.titleInfo}>
              <span className={styles.lastRefreshed}>
                LAST REFRESHED - {formatDate(currentTime)} · 9:00 AM
              </span>
              <div className={styles.currentWeek}>
                CURRENT WEEK: {getCurrentWeek()}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right section with icons and profile */}
      <div className={styles.rightSection}>
        <button
          className={styles.backButton}
          onClick={handleBackClick}
        >
          <ChevronLeft className={styles.backIcon} />
        </button>

        {/* <button
          className={styles.iconButton}
          onClick={handleHomeClick}
          title="Home"
        >
          <Home className={styles.icon} />
        </button> */}

        <button className={styles.iconButton} title="Search">
          <Search className={styles.icon} />
        </button>

        <button className={styles.iconButton} title="Help">
          <HelpOutline className={styles.icon} />
        </button>

        <button className={styles.iconButton} title="Notifications">
          <Notifications className={styles.icon} />
          <span className={styles.notificationDot}></span>
        </button>

        <button 
          className={styles.iconButton} 
          title="Toggle Theme"
        >
          <WbSunny className={styles.icon} />
        </button>

        {/* Profile section with dropdown */}
        <div className={styles.dropdown}>
          <button 
            className={styles.profileButton}
            onClick={() => setShowDropdown(!showDropdown)}
          >
            {userInfo?.avatar ? (
              <img 
                src={userInfo.avatar} 
                alt={userInfo.name || "User"} 
                className={styles.avatar}
              />
            ) : (
              <div className={styles.avatarFallback}>
                {getUserInitials(userInfo?.name)}
              </div>
            )}
            <div className={styles.profileInfo}>
              <span className={styles.profileName}>{userInfo?.name || 'Loading...'}</span>
              <span className={styles.profileRole}>{userInfo?.role || 'User'}</span>
            </div>
            <KeyboardArrowDown className={styles.iconTiny} />
          </button>
          
          {showDropdown && (
        <div className={styles.dropdownContent}>
            <button 
            className={styles.dropdownItem}
            onClick={handleLogout}
            >
            <Logout className={styles.iconSmall} />
            <span>Logout</span>
            </button>
        </div>
        )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;